import type { StrengthLevel, KnownLevel } from '@/types/word'

interface StrengthOption {
  level: StrengthLevel
  label: string
  hint: string
}

/**
 * Schedules the user can set by hand, strongest first. Mirrors
 * SrsSchedulable::STRENGTH_LEVELS on the server. The intervals behind these
 * levels are admin-tunable (SrsSetting), so the hints describe the effect
 * rather than quoting a day count that can change under them.
 */
export const STRENGTH_LEVELS: StrengthOption[] = [
  { level: 'mastered', label: 'Mastered', hint: 'Never appears in reviews' },
  { level: 'well', label: 'Know well', hint: 'Kept in reviews, but scheduled far out' },
  { level: 'new', label: 'Reset to new', hint: 'Back in the queue today, progress cleared' },
]

/** The two levels offered behind "I know this" — resetting is not a way to learn a word. */
export const KNOWN_LEVELS = STRENGTH_LEVELS.filter(
  (option): option is StrengthOption & { level: KnownLevel } => option.level !== 'new',
)
